import React, { Component } from 'react';
import { Trans } from '@lingui/react';
import FileSaver from 'file-saver';
import { addDays, format, parse } from 'date-fns';
import styled from 'styled-components';
import Button from '@components/buttons';
import Divider from '@components/Divider';
import { Box } from '@components/layout/Grid';
import { H4 as h4 } from '@components/typography/Headings';
import { Body, Footer, Header, Modal } from './../base';
import DatePicker from './DatePicker';
import TimePicker from './TimePicker';
import AnalyticsManager from '@lib/analytics/manager';
const H4 = styled(h4)`
  margin: 0;
`;

class ScheduleModal extends Component {
  state = {
    startDate: addDays(new Date(), 1),
    startTime: '1700',
    loadingIcalendar: false,
    loadingGoogle: false,
    open: false,
  };

  handleOpenModal = () => {
    AnalyticsManager().sendClickedScheduleEvent({
      videoId: this.props.resourceId,
    });
    this.setState({
      open: true,
    });
  };

  handleCloseModal = () => {
    this.setState({
      open: false,
    });
    this.props?.onModalClose?.();
  };

  addVideoToSchedule = async ({ returnFormat }) => {
    try {
      const datetime = parse(
        format(this.state.startDate, 'yyyyMMdd') + 'T' + this.state.startTime,
        "yyyyMMdd'T'HHmm",
        new Date()
      ).toISOString();

      const { data } = await this.props.handleSchedule({
        datetime,
        returnFormat,
      });

      if (returnFormat === 'icalendar_file') {
        const blob = new Blob([data.addUserSchedule], {
          type: 'text/calendar',
        });
        FileSaver.saveAs(blob, 'ScheduledVideo.ics');
        this.setState({ loadingIcalendar: false });
      } else {
        // let windowRef;
        // windowRef = window.open();
        // windowRef.location = data.addUserSchedule;
        window.open(data.addUserSchedule.result, '_blank');
        this.setState({ loadingGoogle: false });
      }
    } catch (err) {
      this.setState({ loadingIcalendar: false, loadingGoogle: false });
    }
  };

  render() {
    return (
      <React.Fragment>
        <Modal open={this.state.open} handleClose={this.handleCloseModal}>
          <Header handleClose={this.handleCloseModal}>
            <H4>
              <Trans id="schedule_modal.title" message={'Schedule'} />
            </H4>
          </Header>
          <Body>
            <Box mb={30}>
              <DatePicker
                handleChange={value => {
                  this.setState({
                    startDate: value,
                  });
                }}
              />
            </Box>
            <Box as={Divider} mb={30} />
            <Box>
              <TimePicker
                handleChange={value => {
                  this.setState({
                    startTime: value,
                  });
                }}
              />
            </Box>
          </Body>
          <Footer>
            <Box mb={10} width={1}>
              <Button
                appearance="outline"
                fullWidth
                loading={this.state.loadingIcalendar}
                onClick={() => {
                  this.setState({ loadingIcalendar: true });
                  this.addVideoToSchedule({
                    returnFormat: 'icalendar_file',
                  });
                }}
              >
                <Trans id="schedule_modal.icp" message={'EXPORT .ICS'} />
              </Button>
            </Box>
            <Box mb={10} width={1}>
              <Button
                fullWidth
                loading={this.state.loadingGoogle}
                spinnerColor={'white'}
                onClick={() => {
                  this.setState({ loadingGoogle: true });
                  this.addVideoToSchedule({
                    returnFormat: 'google_url',
                  });
                }}
              >
                <Trans
                  id="schedule_modal.googlecalendar"
                  message={'EXPORT TO GOOGLE CALENDAR'}
                />
              </Button>
            </Box>
          </Footer>
        </Modal>
        {this.props.children(this.handleOpenModal)}
      </React.Fragment>
    );
  }
}
export default ScheduleModal;
